import React, {useState, useEffect} from "react"
import "./Banner.css"
import axios from "./axios"
import requests from "./requests"

function Banner() {
    const [movie,setMovie] = useState([]);
 
    useEffect(() => {
        async function fetchData() {
          const request = await axios.get(requests.fetchNetflixOriginals);
          setMovie(
            request.data.results[
              Math.floor(Math.random() * request.data.results.length )
              // Math.ceil(Math.random() * request.data.results.length - 1)
            ]
          );
          return request;
        }
        fetchData();
      }, []);
    
    //   console.log(movie);
    function truncate(string, n) {
        return string?.length > n ? string.substr(0, n - 1) + "..." : string;
      }

  return (
    <header
          className="banner"
          style={{
         backgroundSize: "cover",
         backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
         backgroundPosition: "center",

    // backgroundImage:`url("https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Black_flag.svg/1280px-Black_flag.svg.png")`,


   
      }}
    >
      <div className="banner_contents">
        <h1 className="banner_title">
          {/* Movie Name  */}
          {movie?.title || movie?.name || movie.original_name}
        </h1>

        <div className="banner_buttons">
              <button className="banner_button">play</button>
              <button className="banner_button">My List </button>
        </div>

        <h1 className="banner_description">
          {truncate(
            `This is a test description written by Alemayehu,Assefa,Alemayehu,Assefa alemayehu assefa alemayehu assefa alemayehu assefa netflex orginal movies `,
            100
          )}
        </h1>
      </div>
      <div className="banner--fadeBottom" />
    </header>
  );
}

export default Banner;